var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReviewAwaiting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 21,
    r: 19,
    fill: "#FFC633"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_5707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4 14H12.6C11.72 14 11 14.72 11 15.6V30L14.2 26.8H25.4C26.28 26.8 27 26.08 27 25.2V15.6C27 14.72 26.28 14 25.4 14ZM14.2 23.6V21.624L19.704 16.12C19.864 15.96 20.112 15.96 20.272 16.12L21.688 17.536C21.848 17.696 21.848 17.944 21.688 18.104L16.176 23.6H14.2ZM23 23.6H17.8L19.4 22H23C23.44 22 23.8 22.36 23.8 22.8C23.8 23.24 23.44 23.6 23 23.6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_5707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11 14)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReviewAwaiting);
export default ForwardRef;